// extracted by mini-css-extract-plugin
module.exports = {"row":"layout_results_control__row__nSmyv display__display_flex__hfG-Z column_xs__itemsTop_xs__YpKfc"};